import request from "@/utils/request";
import Qs from "qs";
/**手机换榜 */
export function getReplacePhone(params) {
  return request({
    url: "/personalCenter/replacePhone",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**修改密码 */
export function getUpdatePassword(params) {
  return request({
    url: "/personalCenter/updatePassword",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**产业 */
export function getIndustry(params) {
  return request({
    url: "/common/lx1",
    method: "post",
    data: Qs.stringify(params)
  });
}
export function getList(params) {
  return request({
    url: "/common/lx2",
    method: "post",
    data: Qs.stringify(params)
  });
}
export function updateUserInfo(params) {
  return request({
    url: "/personalCenter/updateUserInfo",
    method: "post",
    data: Qs.stringify(params)
  });
}
